const L = {
  name: "Size",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5858 4L13.5858 9L15 10.4142L20 5.41421V10H22V2H14V4H18.5858Z" fill="currentColor"/>
<path d="M5.41421 20.0001L10.4142 15.0001L9 13.5858L4 18.5858L4 14.0001L2 14.0001V22.0001L10 22.0001V20.0001L5.41421 20.0001Z" fill="currentColor"/>
<path d="M14.9999 13.5858L13.5857 15L18.5857 20H13.9999V22H21.9999V14H19.9999V18.5858L14.9999 13.5858Z" fill="currentColor"/>
<path d="M4.00009 5.41424L9.00009 10.4142L10.4143 9.00003L5.4143 4.00003L10.0001 4.00003V2.00003L2.00009 2.00003L2.00009 10L4.00009 10L4.00009 5.41424Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as Size
};
